import DashboardLayout from '@/layouts/DashboardLayout';
import OwnAppraisal from './_components/OwnAppraisal';

export default function EmployeeAppraisal() {
  return (
    <DashboardLayout title="Employee Appraisal">
      <OwnAppraisal />
    </DashboardLayout>
  );
}
